import gql from "graphql-tag";
const RegisterUserInteractionMutation = gql`
  mutation RegisterUserInteraction($input: UserInteractionInput!) {
    registerUserInteraction(input: $input)
  }
`;
export default RegisterUserInteractionMutation;
